import {
  compareByNumber as byNumber,
  compareByDate as byDate,
  compareByValue as byValue,
  compareByGrade as byGrade,
} from '@blakeelearning/data-tables/utils/comparisons'

export enum SortType {
  ByValue = 'byValue',
  ByDate = 'byDate',
  ByNumber = 'byNumber',
  ByGrade = 'byGrade',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

interface SortDefinitionArgs {
  sortCol: string
  sortDir: SortDirection
  sortCompare: SortType
}

type CompareFunction = (compareForAscending: boolean, first?: any, second?: any) => number
const compareFunctions: Record<SortType, CompareFunction> = {
  byNumber,
  byDate,
  byValue,
  byGrade,
}

export class SortDefinition {
  sortDirection: SortDirection

  key: string

  compareFunction: CompareFunction

  constructor({ sortCol, sortDir, sortCompare }: SortDefinitionArgs) {
    this.key = sortCol
    this.sortDirection = sortDir
    this.compareFunction = compareFunctions[sortCompare] ?? compareFunctions.byValue
  }
}
